import TrainingAttendance from 'actions/training/attendance';

export default TrainingAttendance.createReducer();